import { FormattedMessage } from 'react-intl';

export function CryptoExposedCol() {
  return (
    <div className="flex-x flex-wrap" style={{ gap: '0px 8px' }}>
      <FormattedMessage id="underlyingUniverse.grid.column.cryptoExposed" />
    </div>
  );
}
